import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4320cb2e&scoped=true&"
import script from "./Footer.vue?vue&type=script&async=true&lang=js&"
export * from "./Footer.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4320cb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320cb2e",
  null
  
)

export default component.exports